// Vehicle-card image-selection helper. Pure function; same inputs always
// produce the same output. Used at render time inside <VehicleCard> to apply
// BR-COMP-002 precedence per render slot.
//
// F289003 — Trim-Aware Imagery (Story 10.3)
// Ref: BR-COMP-002 (precedence chain), BR-IMG-002 (per-category-render scoping),
// BR-IMG-003 (silent fallback to base imagery on miss).
//
// Precedence:
//   1. trim-scoped URL — when activeCategoryTrim is set AND
//      imagesByTrim[activeCategoryTrim].url exists
//   2. base-vehicle GV image URL (silent fallback per BR-IMG-003)
//   3. null — caller renders <NoImage /> placeholder
const selectVehicleCardImageUrl = ({
	imagesByTrim,
	activeCategoryTrim,
	baseImageUrl
}) => {
	if (
		activeCategoryTrim &&
		imagesByTrim &&
		imagesByTrim[activeCategoryTrim] &&
		imagesByTrim[activeCategoryTrim].url
	) {
		return imagesByTrim[activeCategoryTrim].url;
	}
	return baseImageUrl || null;
};

export default selectVehicleCardImageUrl;
